import { Injectable } from '@angular/core';

import * as fa from '@fortawesome/pro-solid-svg-icons';

@Injectable({
  providedIn: 'root',
})
export class IconsService {
  private _icons = fa;

  constructor() {}

  /**
   * Returns icons list
   */
  public getIcons(): typeof fa {
    return this._icons;
  }

  /**
   * Resolves a FontAwesome icon for a file extension, with or without a leading dot
   * and in any casing. Returns null when the extension has no mapping - callers must
   * supply their own fallback. Never return a partial IconDefinition: `fa-icon` throws
   * on anything it cannot resolve, and the throw repeats every change detection cycle.
   */
  public getIconByExtension(name: string): fa.IconDefinition | null {
    const extension = name?.toLowerCase().replace(/^\./, '');

    switch (extension) {
      case 'xls':
      case 'xlsx':
        return this._icons.faFileExcel;

      case 'csv':
        return this._icons.faFileCsv;

      case 'doc':
      case 'docx':
        return this._icons.faFileWord;

      case 'ppt':
      case 'pptx':
        return this._icons.faFilePowerpoint;

      case 'pdf':
        return this._icons.faFilePdf;

      case 'txt':
        return this._icons.faFile;

      case 'png':
      case 'jpg':
      case 'jpeg':
      case 'gif':
      case 'bmp':
      case 'svg':
      case 'webp':
        return this._icons.faFileImage;

      case 'zip':
      case 'rar':
      case '7z':
      case 'gz':
      case 'tar':
        return this._icons.faFileArchive;

      case 'xml':
      case 'json':
        return this._icons.faFileCode;

      default:
        return null;
    }
  }
}
